import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDafComponent } from './simple-icons-daf.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDafComponent ],
    exports:      [ SimpleIconsDafComponent ],
    bootstrap:    []
})
export class SimpleIconsDafModule {}
